var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 88.07,
    height: 64.082,
    viewBox: "0 0 88.07 64.082",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "svgexport-17",
    transform: "translate(0 -66.65)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32348",
    "data-name": "Path 32348",
    d: "M68.815,130.732H49.92V111.639h6.244a1.953,1.953,0,0,0,1.584-3.1L45.6,91.736a1.936,1.936,0,0,0-3.149,0L30.3,108.544a1.949,1.949,0,0,0,1.584,3.1h6.244v19.093H16.97C7.522,130.21,0,121.375,0,111.8A17.927,17.927,0,0,1,8.89,96.325a12.019,12.019,0,0,1-.738-4.193,12.188,12.188,0,0,1,12.2-12.2,11.993,11.993,0,0,1,4.175.738,24.426,24.426,0,0,1,46.411,8.062C80.674,90.4,88.07,99.42,88.07,109.623c0,10.905-8.494,20.353-19.255,21.109Z",
    fill: "#d2d2d2"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.1d053987451a416a792c2a7479a68411.svg";
export { ForwardRef as ReactComponent };